import classNames from "classnames";
import React from "react";

interface BuyButtonI {
	label: string;
	className?: string;
	onClickHandler: () => void;
	tabIndex?: number | undefined;
}

const BuyButton = ({ label, className = "primary", onClickHandler, tabIndex }: BuyButtonI) => (
	<button
		aria-label={label}
		className={classNames("addtocart-button btn btn-medium background-transition", className)}
		onClick={onClickHandler}
		tabIndex={tabIndex}
		type="button"
	>
		<span dangerouslySetInnerHTML={{ __html: label }}></span>
	</button>
);

export default BuyButton;
